module.exports = {"530523101":"龙山镇","530523102":"镇安镇","530523103":"勐糯镇","530523104":"腊勐镇","530523105":"象达镇","530523201":"龙江乡","530523203":"碧寨乡","530523204":"龙新乡","530523206":"平达乡","530523207":"木城彝族傈僳族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530523.json
// module id = 2711
// module chunks = 0